import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=95de0884"
import script from "./SubscriptionForm.vue?vue&type=script&lang=ts"
export * from "./SubscriptionForm.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionForm.vue?vue&type=style&index=0&id=95de0884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports